import { render, staticRenderFns } from "./AppEdn.vue?vue&type=template&id=00847bb0&"
import script from "./AppEdn.vue?vue&type=script&lang=js&"
export * from "./AppEdn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports